module.exports = __webpack_public_path__ + "a47a0a632285f6954f9e3e461fffda84.svg";